export default __webpack_public_path__ + "static/media/1.32aebf67.jpg";